import _ from "lodash";

// Offsets a map location by a given pixel offset in {x, y}
export const offsetMapLocation = (map, location, offset) => {
    offset.x = offset.x || 0;
    offset.y = offset.y || 0;

    var screenPosition = map.geoToScreen(location);
    return map.screenToGeo(screenPosition.x + offset.x, screenPosition.y + offset.y);
}

export const drawDepot = (map, depot) => {
    try {
        switch (depot.depotType) {
            case "circle": drawDepotCircle(map, depot); break;
            case "rectangle": drawDepotPolygon(map, depot); break;
            case "polygon": drawDepotPolygon(map, depot); break;
            default: break;
        }
    } catch (ex) {
        console.warn("Failed to draw depot:", ex);
    }
}

let bubble;
function openBubble(evt, text) {
    let position = evt.target.getGeometry();
    if (!bubble) {
        bubble = new window.H.ui.InfoBubble(evt.target.loc,{ content: text });
        window.ui.addBubble(bubble);
    } else {
        bubble.setPosition(position);
        bubble.setContent(text);
        bubble.open();
    }
};

function closeBubble() {
    if (bubble) {
        bubble.close();
        bubble = null;
    }
};
function drawDepotCircle(map, depot) {
    var loc = { lat: depot.center.latitude, lng: depot.center.longitude };
    var circle = new window.H.map.Circle(
        { lat: depot.center.latitude, lng: depot.center.longitude },
        depot.radius,
        {
            style: { fillColor: "rgba(0, 0, 0, 0.4)", lineWidth: 0 },
        }
    );
    circle.loc = loc;
    circle.addEventListener('pointerenter', (evt) => {
        onpointerenter(evt,depot.depotName) 
    });

    circle.addEventListener('pointerleave', closeBubble);

    map.addObject(circle);
}

function onpointerenter(evt,depotName) {
    closeBubble();
    let depotInfo = `<div style="white-space: nowrap;">${depotName}</div>`;
    openBubble(evt, depotInfo);
}

function drawDepotPolygon(map, depot) {
    var polygon = depot.locations.map((location) => {
        return [location.latitude, location.longitude, 0];
    });

    var mapPolygon = new window.H.map.Polygon(
        new window.H.geo.LineString(_.flatten(polygon)),
        {
            style: { fillColor: "rgba(0, 0, 0, 0.4)", lineWidth: 0 },
        }
    );

    map.addObject(mapPolygon);
}
